import React from 'react';
import { TextInput, TextArea, StringList, CardList, Toggle, SectionHeader } from './Fields';

const PlanosEditor = ({ data, onChange }) => {
  const set = (key, val) => onChange({ ...data, [key]: val });

  return (
    <div>
      <SectionHeader title="Seção Planos e Preços" />
      <TextInput label="Título" value={data.heading} onChange={v => set('heading', v)} />
      <TextArea label="Subtítulo" value={data.subheading} onChange={v => set('subheading', v)} />
      <TextInput label="Nota de rodapé" value={data.footnote} onChange={v => set('footnote', v)} hint="Ex: * Valores para 100 usuários." />

      <Toggle
        label="Ocultar preços no site"
        value={data.hidePrice}
        onChange={v => set('hidePrice', v)}
      />

      <CardList
        label="Planos"
        value={data.plans}
        onChange={v => set('plans', v)}
        emptyCard={{ name: '', price: '', period: '/mês*', features: [], buttonText: 'Saiba Mais', isPopular: false }}
        renderCard={(item, i, update) => (
          <div className="space-y-3">
            <div className="grid grid-cols-2 gap-2">
              <TextInput label="Nome do plano" value={item.name} onChange={v => update({ name: v })} placeholder="SCALE" />
              <TextInput label="Preço" value={item.price} onChange={v => update({ price: v })} placeholder="R$ 5.990" />
            </div>
            <div className="grid grid-cols-2 gap-2">
              <TextInput label="Período" value={item.period} onChange={v => update({ period: v })} placeholder="/mês*" />
              <TextInput label="Texto do botão" value={item.buttonText} onChange={v => update({ buttonText: v })} />
            </div>
            <Toggle
              label="Plano popular (destaque verde)"
              value={item.isPopular}
              onChange={v => update({ isPopular: v })}
            />
            <StringList
              label="Features incluídas"
              value={item.features}
              onChange={v => update({ features: v })}
              placeholder="Ex: Controle de processos"
            />
          </div>
        )}
      />
    </div>
  );
};

export default PlanosEditor;
